// Seed data for RedCard (FanCode clone)

export const heroSlides = [
{
  id: '1',
  status: 'UPCOMING',
  teamA: 'South Australia',
  teamB: 'Tasmania',
  tournament: 'One Day Cup, 2026/27',
  matchInfo: 'Match 5',
  time: 'Today, 6:00 am',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/4249275_53072_SAU_TAS_FC-WebTVBG.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhLzQyNDkyNzVfNTMwNzJfU0FVX1RBU19GQy1XZWJUVkJHLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjoxOTIwLCJoZWlnaHQiOjEwODB9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9',
  sport: 'cricket'
},
{
  id: '2',
  status: 'LIVE',
  teamA: 'Bayern Munich Women',
  teamB: 'Manchester City Women',
  tournament: "UEFA Women\'s Champions League 2026-27",
  matchInfo: 'Round of 16',
  time: 'Live Now',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  sport: 'football'
},
{
  id: '3',
  status: 'UPCOMING',
  teamA: 'India',
  teamB: 'Japan',
  tournament: 'India tour of Japan, 2026',
  matchInfo: 'T20I Series',
  time: 'Tomorrow, 2:00 pm',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14062a9fb-1773867853033.png",
  sport: 'cricket'
}];


export const liveMatches = [
{
  id: '1',
  tournament: 'DP World ILT20 Development Tournament 2026',
  teamA: 'Sharjah Warriorz Development',
  teamB: 'Abu Dhabi Knight Riders Development',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4cf68a07b-1790109473838.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4cf68a07b-1790109473838.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4cf68a07b-1790109473838.png",
  status: 'LIVE',
  isFree: false,
  sport: 'cricket'
},
{
  id: '2',
  tournament: "UEFA Women\'s Champions League 2026-27",
  teamA: 'Bayern Munich Women',
  teamB: 'Manchester City Women',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  status: 'LIVE',
  isFree: false,
  sport: 'football'
},
{
  id: '3',
  tournament: "UEFA Women\'s Champions League 2026-27",
  teamA: 'Inter Women',
  teamB: 'BK Häcken Women',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  status: 'LIVE',
  isFree: true,
  sport: 'football'
},
{
  id: '4',
  tournament: "UEFA Women\'s Champions League 2026-27",
  teamA: 'Arsenal Women',
  teamB: 'HB Køge Women',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  status: 'LIVE',
  isFree: false,
  sport: 'football'
},
{
  id: '5',
  tournament: "UEFA Women\'s Champions League 2026-27",
  teamA: 'Juventus Women',
  teamB: 'Benfica Women',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c62bc8ec-1790109471766.png",
  status: 'LIVE',
  isFree: false,
  sport: 'football'
},
{
  id: '6',
  tournament: "UEFA Women\'s Champions League 2026-27",
  teamA: 'Real Madrid Women',
  teamB: 'Paris Saint-Germain Women',
  teamALogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae6dd2a7-1763299044199.png",
  teamBLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae6dd2a7-1763299044199.png",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae6dd2a7-1763299044199.png",
  status: 'LIVE',
  isFree: false,
  sport: 'football'
}];


export const popularTours = [
{
  id: '1',
  rank: 1,
  name: 'India tour of Japan, 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14062a9fb-1773867853033.png",
  sport: 'cricket'
},
{
  id: '2',
  rank: 2,
  name: 'World Championship of Legends, 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15081517d-1772636309114.png",
  sport: 'cricket'
},
{
  id: '3',
  rank: 3,
  name: 'One Day Cup, 2026/27',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/IMG_6105.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL0lNR182MTA1LnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjoyODQsImhlaWdodCI6NDI2fSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ==',
  sport: 'cricket'
},
{
  id: '4',
  rank: 4,
  name: 'IFA Shield 2026',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/TV_vertical_IFA.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL1RWX3ZlcnRpY2FsX0lGQS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsiZml0IjoiY292ZXIiLCJ3aWR0aCI6Mjg0LCJoZWlnaHQiOjQyNn0sIndlYnAiOnsicXVhbGl0eSI6NjAsImxvc3NsZXNzIjpmYWxzZX19LCJvdXRwdXRGb3JtYXQiOiJ3ZWJwIn0=',
  sport: 'football'
},
{
  id: '5',
  rank: 5,
  name: 'LALIGA 2026-27',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/LaLiga-TV-Vertical_1787046845462.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL0xhTGlnYS1UVi1WZXJ0aWNhbF8xNzg3MDQ2ODQ1NDYyLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjoyODQsImhlaWdodCI6NDI2fSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ==',
  sport: 'football'
},
{
  id: '6',
  rank: 6,
  name: 'F1 QATAR AIRWAYS AZERBAIJAN GRAND PRIX 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_42f2a23a0-1790109470513.png",
  sport: 'formula1'
},
{
  id: '7',
  rank: 7,
  name: "Barclays Women\'s Super League 2026-27",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4bcc8b099-1790109471325.png",
  sport: 'football'
},
{
  id: '8',
  rank: 8,
  name: 'ATP 250 - Hangzhou Open 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1415f8cfa-1778663535581.png",
  sport: 'tennis'
},
{
  id: '9',
  rank: 9,
  name: 'F1 GULF AIR BAHRAIN GRAND PRIX IN MALAYSIA 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4d6b70d7a-1790109470257.png",
  sport: 'formula1'
},
{
  id: '10',
  rank: 10,
  name: 'F1 SINGAPORE AIRLINES SINGAPORE GRAND PRIX 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_184bef933-1777761475054.png",
  sport: 'formula1'
}];


export const subscriptionCards = [
{
  id: '1',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/card_01.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL2NhcmRfMDEucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjQ4MCwiaGVpZ2h0IjozMzd9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9',
  alt: 'Watch Your Way - Match Pass'
},
{
  id: '2',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/card_02.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL2NhcmRfMDIucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjQ4MCwiaGVpZ2h0IjozMzd9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9',
  alt: 'Watch On Any Device'
},
{
  id: '3',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/card_03.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL2NhcmRfMDMucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjQ4MCwiaGVpZ2h0IjozMzd9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9',
  alt: 'All Sports One Platform'
},
{
  id: '4',
  image: 'https://images.fancode.com/skillup-uploads/cms-media/card_04.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvY21zLW1lZGlhL2NhcmRfMDQucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjQ4MCwiaGVpZ2h0IjozMzd9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9',
  alt: 'Premium Subscription'
}];


export const videoHighlights = [
{
  id: '1',
  title: 'India beat Japan by 2 runs | English highlights',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1a30e3eee-1773045474309.png",
  duration: '10:06',
  type: 'HIGHLIGHTS',
  tour: 'India tour of Japan 2026',
  sport: 'cricket'
}];


export const scheduleItems = [
{
  id: '1',
  sport: 'cricket',
  teamA: 'South Australia',
  teamB: 'Tasmania',
  tournament: 'One Day Cup, 2026/27',
  matchInfo: 'Match 5',
  time: 'Today, 6:00 am',
  status: 'UPCOMING'
},
{
  id: '2',
  sport: 'cricket',
  teamA: 'India',
  teamB: 'Japan',
  tournament: 'India tour of Japan, 2026',
  matchInfo: 'T20I Match 3',
  time: 'Tomorrow, 2:00 pm',
  status: 'UPCOMING'
},
{
  id: '3',
  sport: 'football',
  teamA: 'Real Madrid',
  teamB: 'Barcelona',
  tournament: 'LALIGA 2026-27',
  matchInfo: 'Match 28',
  time: 'Sat, 10:00 pm',
  status: 'UPCOMING'
},
{
  id: '4',
  sport: 'formula1',
  teamA: 'F1 Azerbaijan Grand Prix',
  teamB: '',
  tournament: 'F1 QATAR AIRWAYS AZERBAIJAN GRAND PRIX 2026',
  matchInfo: 'Race Day',
  time: 'Sun, 3:00 pm',
  status: 'UPCOMING'
}];